<div class="dialog-content">
  <div class="content">
    <p class="title">{{'DIALOGS.LEAVE_TEST.TITLE' | translate}}</p>
    <p class="subtitle">{{'DIALOGS.LEAVE_TEST.SUBTITLE' | translate}}</p>
    <button (click)="closeDialog(true)" class="leave">{{'DIALOGS.LEAVE_TEST.LEAVE_BUTTON' | translate}}</button>
    <button (click)="closeDialog(false)" class="continue">{{'DIALOGS.LEAVE_TEST.CONTINUE_BUTTON' | translate}}</button>
  </div>
</div>
